import {Typography} from "@mui/material";

export const WorkQueueContractInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Returned Data Points',
                content: 'Select the Data Points that you want to see on the Dashboard.  ' +
                    'Choose the order in which they will display.'
            };

        default:
            // case 'Drilldown':
            return {
                title: 'Contracts',
                content: (
                    <>
                        <Typography paragraph>
                            Contracts are listed in the context of the
                            Properties to which they relate.
                        </Typography>

                        <ul>
                            <li>
                                Contracts are organized in a hierarchy based on
                                Contract Level.
                            </li>

                            <li>
                                Click the <strong>&gt;</strong> icon to expand
                                a contract and view the contracts
                                beneath it.
                            </li>

                            <li>
                                Use the menu in the middle of the row to perform
                                available contract actions.
                            </li>

                            <li>
                                Click the status circle to update the status of
                                a contract.
                            </li>

                            <li>
                                Click the contract name to view the
                                contract contents.
                            </li>

                            <li>
                                This view helps you navigate the contractual
                                structure for a Property and understand how each
                                contract relates to the larger contract hierarchy.
                            </li>
                        </ul>
                    </>
                )
            };
    }
};








